import { Reveal, SectionTag } from "@/components/Reveal";

export default function BookItIn() {
  return (
    <section id="book-it-in" data-testid="book-it-in-section" className="border-b-2 border-white/10 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionTag number="07" label="Book It In" color="#ff66c4" />

        <Reveal>
          <h2 className="max-w-4xl font-display text-4xl uppercase leading-[0.9] tracking-tight sm:text-6xl">
            Easy to use{" "}
            <span className="text-[#ff66c4]">booking portal.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="mt-6 max-w-2xl text-base leading-relaxed text-zinc-300 md:text-lg">
          <p data-testid="book-it-in-copy">
            Use our booking portal below — have us come to your property and we will
            arrive onsite with all the equipment ready to go! Simply, select Plumber,
            select your date and time, tell us your name and where to find you, and tell
            us about your blockage in the job description — we will see you onsite!
          </p>
        </Reveal>

        <Reveal delay={0.15} className="mt-12">
          <div
            className="shadow-hard-pink border-2 border-[#ff66c4] bg-white"
            data-testid="booking-widget-frame"
          >
            <iframe
              src="https://plumbing-electrical-booking-widget.vercel.app/embed"
              title="Book a plumber or electrician"
              width="100%"
              style={{ minHeight: "720px", border: 0, width: "100%", display: "block" }}
              loading="lazy"
              referrerPolicy="strict-origin-when-cross-origin"
              data-testid="booking-widget-iframe"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
